import { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import { HiMiniStrikethrough } from "react-icons/hi2";
import { FiBold, FiItalic } from "react-icons/fi";
import { MdFormatListBulleted } from "react-icons/md";
import { PiCodeBlockBold, PiListNumbers } from "react-icons/pi";
import { IoCodeSlash } from "react-icons/io5";
import { RiQuoteText } from "react-icons/ri";

const TextEditor = ({ placeholder, value, onChange, onSubmit }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        hardBreak: true,
      }),
      Placeholder.configure({
        placeholder: placeholder || "Write a message...",
      }),
    ],
    content: value,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
    editorProps: {
      attributes: {
        class: "slack-editor",
      },
      handleKeyDown(view, event) {
        if (
          event.key === "Enter" &&
          !event.shiftKey &&
          !editor.isActive("codeBlock")
        ) {
          event.preventDefault();
          const text = editor.getText().trim();
          if (text.length > 0) {
            onSubmit(editor.getHTML());
            editor.commands.clearContent();
          }
          return true;
        }
        return false;
      },
    },
  });

  useEffect(() => {
    if (!editor) return;
    if (!value) {
      editor.commands.clearContent();
    }
  }, [value, editor]);

  if (!editor) return null;
  return (
    <div className="slack-editor-wrapper">
      <div className="slack-toolbar">
        <button
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={editor.isActive("bold") ? "is-active" : ""}
        >
          <FiBold />
        </button>

        <button
          onClick={() => editor.chain().focus().toggleItalic().run()}
          className={editor.isActive("italic") ? "is-active" : ""}
        >
          <FiItalic />
        </button>

        <button
          onClick={() => editor.chain().focus().toggleStrike().run()}
          className={editor.isActive("strike") ? "is-active" : ""}
        >
          <HiMiniStrikethrough />
        </button>

        <button
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={editor.isActive("bulletList") ? "is-active" : ""}
        >
          <MdFormatListBulleted />
        </button>

        <button
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={editor.isActive("orderedList") ? "is-active" : ""}
        >
          <PiListNumbers />
        </button>

        <button
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          className={editor.isActive("blockquote") ? "is-active" : ""}
        >
          <RiQuoteText />
        </button>

        {/* Inline Code */}
        <button
          onClick={() => editor.chain().focus().toggleCode().run()}
          className={editor.isActive("code") ? "is-active" : ""}
        >
          <IoCodeSlash />
        </button>

        {/* Code Block */}
        <button
          onClick={() => editor.chain().focus().toggleCodeBlock().run()}
          className={editor.isActive("codeBlock") ? "is-active" : ""}
        >
          <PiCodeBlockBold />
        </button>
      </div>

      <EditorContent editor={editor} />
    </div>
  );
};

export default TextEditor;
